<script>
import { pollUnreadLuckyDrops } from '@/utils/lucky-drop'
import { useUserStore } from '@/store/user'
import { loadAppFont } from '@/utils/fonts'

export default {
  onLaunch() {
    loadAppFont()
    try {
      useUserStore().syncTokenFromStorage()
    } catch (e) {
      /* pinia not ready */
    }
  },
  onShow() {
    try {
      useUserStore().syncTokenFromStorage()
      if (useUserStore().isLoggedIn()) {
        pollUnreadLuckyDrops()
      }
    } catch (e) {
      /* pinia not ready */
    }
  },
}
</script>

<template>
  <global-lucky-drop-host />
</template>

<style lang="scss">
@import '@/styles/theme.scss';
@import '@/styles/fonts.scss';
</style>
